import React from 'react';
import { string, bool, shape } from 'prop-types';

export default function TextMediaTile({ item }) {
    if (item.cssModifier === 'category-heading-block') {
        if (!(window.location.href.indexOf('categories') > 0)) {
            item.cssModifier += ' hide';
        }
    }

    return (
        <section className={`cw-text-media ${item.bgClass ? item.bgClass : ''} ${item.cssModifier ? item.cssModifier : ''}`}>
            <div className="container">
                <div className={`row ${item.reverse ? 'grid-reverse' : ''}`}>
                    <div className="media-wrapper">
                        {item.imgUrl &&
                            <div className="ratio-wrapper">
                                <img src={item.imgUrl} alt="" />
                            </div>
                        }
                    </div>
                    <div className="text-wrapper">
                        <h3>{item.title}</h3>
                        {item.wysiwygEditor
                            ? <div className="wysiwyg-content" dangerouslySetInnerHTML={{ __html: item.wysiwygEditor }} />
                            : <p>{item.paragraph}</p>
                        }
                        {item.btnUrl &&
                            <a href={item.btnUrl} className="btn btn-skin-1 btn-small">{item.btnText}</a>
                        }
                    </div>
                </div>
            </div>
        </section>
    );
}

TextMediaTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        cssModifier: string,
        bgClass: string,
        reverse: bool,
        imgUrl: string,
        title: string.isRequired,
        wysiwygEditor: string,
        paragraph: string,
        btnUrl: string,
        btnText: string
    }).isRequired
    /* eslint-enable react/no-typos */
};



// WEBPACK FOOTER //
// ./src/components/tiles/TextMediaTile.jsx